<template>
  <div>
    <div class="news-list" @click="goDetails(item.id)" v-for="item in newsList" :key="item.id">
      <div class="imgs">
        <img :src="item.poster" />
      </div>
      <div class="news-data">
        <div class="data1">
          <div class="titles">{{item.title}}</div>
          <!--                <div class="times">2020-08-22</div>-->
        </div>
        <div class="info">
          <div>{{getCutContent(item.content)}}</div>
        </div>
        <div class="data2">
          <div class="authors">
            <div class="times">{{item.create_time}}</div>
          </div>
          <div class="news-info">
            <a-icon class="ant-icon" type="eye" theme="filled" />
            {{item.visits}}
            <!--                    <a-icon class="ant-icon" type="like" theme="filled"/>50-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    newsList: {
      type: Array,
      default: () => [],
    },
  },
  name: "newList",
  methods: {
    goDetails(id) {
      const { href } = this.$router.resolve({
        path: "/new/" + id,
      });
      window.open(href, "_blank");
    },
    getCutContent(content) {
      let primaryContent = content.replace(/<(?!p).*?>/gi, ""); //去除除了p標籤的所有標籤
      let cutContent = primaryContent.replace(/<[^>]+>|&[^>]+;/g, "");
      if (cutContent.length > 100) {
        cutContent = cutContent.substr(0, 100);
      }
      return cutContent;
    },
  },
};
</script>

<style lang="less" scoped>
.news-list {
  display: flex;
  margin-left: -20px;
  margin-right: -20px;
  padding: 20px;
  cursor: pointer;
  &:hover{
    background-color: #fafafa;
  }
  .imgs {
    flex-shrink: 0;
    width: 250px;
    height: 150px;
    overflow: hidden;
    background-color: #f8f8f8;
    img {
      width: 100%;
      height: 100%;
      transition: transform 0.3s ease;
    }
  }
  .news-data {
    padding-left: 30px;
    box-sizing: border-box;
    width: 100%;
    .data1 {
      display: flex;
      justify-content: space-between;
      align-items: center;
      .titles {
        width: 100%;
        overflow: hidden;
        font-size: 18px;
        color: #333;
      }
      .times {
        flex-shrink: 0;
        font-size: 12px;
        color: #aaa;
      }
    }
    .info {
      margin-top: 5px;
      line-height: 180%;
      color: #666;
      height: 80px;
      overflow: hidden;
      div {
        overflow: hidden;
        text-overflow: ellipsis;
        display: -webkit-box;
        -webkit-box-orient: vertical;
        -webkit-line-clamp: 2;
      }
    }
    .data2 {
      display: flex;
      align-items: center;
      .authors {
        img {
          width: 30px;
          height: 30px;
          border-radius: 50%;
          overflow: hidden;
        }
        span {
          margin-left: 6px;
          color: #333;
          font-size: 12px;
        }
        .times {
          color: #aaaaaa;
        }
      }
      .news-info {
        color: #aaaaaa;
        margin-left: 20px;
        .ant-icon {
          margin: 0 3px 0 12px;
          font-size: 12px;
          color: #ccc;
        }
      }
    }
  }
}
.news-list:hover {
  .imgs > img {
    transform: scale(1.1);
  }
  .news-data {
    .data1 {
      .titles {
        color: #0a67fb;
      }
    }
  }
}
@media (max-width: 767px) {
  .news-list {
    margin-left: 0;
    margin-right: 0;
    padding: 0;
    margin-bottom: 20px;
    padding-bottom: 20px;
    border-bottom: 1px solid #e1e1e1;
    flex-wrap: wrap;
    &:hover{
      background-color: transparent;
    }
    .imgs {
      width: 100%;
      height: calc(100vw * 0.56);
    }
    .news-data {
      padding-left: 0;
      margin-top: 15px;
      .data1 {
        justify-content: space-between;
        .titles {
          font-size: 16px;
        }
        .times {
          display: none;
        }
      }
      .info {
        height: auto;
        div {
          overflow: hidden;
          text-overflow: ellipsis;
          display: -webkit-box;
          -webkit-box-orient: vertical;
          -webkit-line-clamp: 3;
        }
      }
      .data2 {
        margin-top: 10px;
        justify-content: space-between;
        .news-info {
          margin-left: 0;
        }
      }
    }
  }
}
</style>